import { isSatisfyOption } from 'shared/lib';

import { CONFIRMATION_FORM_FIELDS } from './PreApprovalConfirmationForm.config';
import type { ConfirmationFormValues } from './schema';
import { CONFIRMATION_STATUS_CODES } from './useSendSmsConfirmation';

export const getConfirmationFormData = (): ConfirmationFormValues => {
  return {
    [CONFIRMATION_FORM_FIELDS.SMS_CODE]: '',
  };
};

export const hasSmsConfirmationError = (code?: number) =>
  !isSatisfyOption(
    [
      CONFIRMATION_STATUS_CODES.SUCCESS,
      CONFIRMATION_STATUS_CODES.CREATED,
      CONFIRMATION_STATUS_CODES.SEND_DOUBLE_SMS,
      CONFIRMATION_STATUS_CODES.TOO_MANY_REQUESTS,
    ],
    code,
  );
